module.exports = __webpack_public_path__ + "img/reference03.e339eacc.jpg";